import { SelectProps } from "@cofano/cck/Select/Select";
import { ReeferCheckType } from "__generated__/graphql";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";

const ReeferCheckTypeSelect = ({ value, onChange, types }: Omit<SelectProps<ReeferCheckType, false>, "fetchOptions"> & { types?: ReeferCheckType[] }) => {
	const fetchOptions = types ? types : Object.values(ReeferCheckType);

	return (
		<Select
			clearable={false}
			fetchOptions={fetchOptions}
			getOptionLabel={(option) => intl.formatMessage({ id: `REEFER_CHECK_TYPE_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default ReeferCheckTypeSelect;
